// extracted by mini-css-extract-plugin
export default {"coverletterButton":"Coverletter_coverletterButton__d43AK"};